import { TimelinePost } from '@/types/post'

interface PostEngagementProps {
  post: TimelinePost
}

export function PostEngagement({ post }: PostEngagementProps) {
  const likes = post.metadata?.likeCount ?? post.properties?.likeCount ?? 0
  const retweets = post.metadata?.retweetCount ?? post.properties?.retweetCount ?? 0
  const comments = post.metadata?.replyCount ?? post.properties?.replyCount ?? post.metadata?.commentCount ?? 0

  const formatCount = (count: number): string => {
    if (count === 0) return '—'
    if (count >= 1000) {
      const thousands = count / 1000
      const formatted = thousands % 1 === 0 
        ? thousands.toString() 
        : thousands.toFixed(1).replace('.', ',')
      return `${formatted}K`
    }
    return count.toString()
  }

  const hasAnyEngagement = likes > 0 || retweets > 0 || comments > 0

  if (!hasAnyEngagement) {
    return null
  }

  return (
    <div className="flex items-center gap-4 text-sm">
      {likes > 0 && (
        <div className="flex items-center gap-1">
          <span className="font-semibold text-black">{formatCount(likes)}</span>
          <span className="text-gray-700">likes</span>
        </div>
      )}
      {retweets > 0 && (
        <div className="flex items-center gap-1">
          <span className="font-semibold text-black">{formatCount(retweets)}</span>
          <span className="text-gray-700">RTs</span>
        </div>
      )}
      {comments > 0 && (
        <div className="flex items-center gap-1">
          <span className="font-semibold text-black">{formatCount(comments)}</span>
          <span className="text-gray-700">comentários</span>
        </div>
      )}
    </div>
  )
}
